import { Loading } from '@library/components/Loading';

export interface MemberFetchStatusProps {
  apiContextMessage?: string;
  isError: boolean;
  isLoading: boolean;
  isMemberNotFound: boolean;
  loadingMessage?: string;
}

export const MemberFetchStatus = ({
  apiContextMessage = 'Member Details',
  isError,
  isLoading,
  isMemberNotFound,
  loadingMessage = 'Loading Member Details'
}: MemberFetchStatusProps) => {
  if (isLoading) {
    return <Loading loadingMessage={loadingMessage} />;
  }

  if (isError) {
    return (
      <h1 className="text-soClean-100 m-auto text-xl font-bold">
        Error Fetching {apiContextMessage}
      </h1>
    );
  }

  if (isMemberNotFound) {
    return (
      <h1 className="text-soClean-100 m-auto text-xl font-bold">
        Member Not Found
      </h1>
    );
  }

  return null;
};
